import { Headings } from "@sentara-health/optimahealth_web";
import { useTranslation } from 'react-i18next';

export default function ViewEligibilityHeader() {
  const { t } = useTranslation();
  return (
    <div>
      <Headings
        className="fw-600 mb-4"
        level={1}
        text={t("viewEligibilityForm.header")}
        dataTestId="txtMemberEligibilityPageHeading"
      />
    </div>
  )
}
